export default function InfoCard({ children, className }) {
    return (
        <div className={`${className}  rounded-2xl p-1 cri-gradient-bl-to-tr border border-sky-50 border-opacity-30`}>
            <div className={`flex flex-col justify-center items-center w-full h-full text-white text-center py-2 space-y-3`}>{children}</div>
        </div>
    );
}
